(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/views/team-result.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/views/team-result.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.views = svs.matchen.views || {};

  svs.matchen.views.TeamResult = Marionette.View.extend({
    className: 'view-team-result team-result',

    template: function(data) {
      return svs.matchen.templates.team_result(data);
    },

    templateContext: function() {
      return {
        isValidResult: this.model.isValidResult()
      };
    },

    initialize: function() {
      if (!(this.model instanceof svs.matchen.models.Result)) {
        this.model = new svs.matchen.models.Result();
      }
    }
  });
})(Backbone, _, svs);


 })(window);